//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect.vue'
import SearchInput from '@/components/SearchInput.vue'
import productosApi from "@/api/promotores/productos.api";

const campos_producto_libre = [
  {label: 'Nombre Completo', field: 'nombre_completo'},
  {label: 'Correo', field: 'correo'},
  {label: 'Regimen Fiscal', field: 'regimen_fiscal', mutator: 'regimen_fiscal'},
  {label: 'Nombre Empresa', field: 'nombre_empresa'},
  {label: 'Griro del Negocio', field: 'giro_negocio'},
  {label: 'Total ventas mensuales', field: 'total_ventas_mensuales_negocio', mutator: 'money_format'},
  {label: 'Tiempo operacion actividad actual', field: 'tiempo_operacion_actividad_actual'},
  {label: '¿Sus ingresos dependen del gobierno?', field: 'ingresos_depende_gobierno_cliente'},
  {label: 'Monto solicitado', field: 'monto_solicitado', mutator: 'money_format'},
  {label: 'Total pagos deudas mensual', field: 'total_pagos_deudas_mensual', mutator: 'money_format'},
  {label: 'Porcentaje de garancias', field: 'porcentaje_ganancias'},
  {label: 'Sitio web', field: 'sitio_web'},

  {label: 'Estado', field: 'entidad'},
  {label: 'CP', field: 'cp'},
  {label: 'Colonia', field: 'colonia'},
  {label: 'Municipio', field: 'municipio'},
  {label: 'Calle', field: 'calle'},
  {label: 'Numero', field: 'numero'},
  {label: 'Url Maps', field: 'link_ubicacion'},
]

const campos_producto_flex = [
  {label: 'Nombre Completo', field: 'nombre_completo'},
  {label: 'Razón social', field: 'razon_social', mutator: 'regimen_fiscal'},
  {label: 'Correo', field: 'correo'},
  {label: 'Celular', field: 'celular'},
  {label: 'Línea de crédito solicitada', field: 'linea_credito_solicitada', mutator: 'money_format'},
  {label: 'Tipo de garantía', field: 'tipo_garantia', mutator: 'tipo_garantia'},
  {label: 'Valor estimado del inmueble', field: 'valor_estimado_inmueble', mutator: 'money_format'},
  {label: 'M² de terreno', field: 'superficie_terreno'},
  {label: 'M² construidos', field: 'area_construida'},


  {label: 'Direccion Solicitante (Estado)', field: 'entidad'},
  {label: 'Direccion Solicitante (CP)', field: 'cp'},
  {label: 'Direccion Solicitante (Colonia)', field: 'colonia'},
  {label: 'Direccion Solicitante (Municipio)', field: 'municipio'},
  {label: 'Direccion Solicitante (Calle)', field: 'calle'},
  {label: 'Direccion Solicitante (Numero)', field: 'numero'},
  {label: 'Url Maps', field: 'link_ubicacion'},
]

const campos_producto_anticipo_venta = [
  {label: 'Nombre Completo', field: 'nombre_completo'},
  {label: 'Razón social', field: 'razon_social', mutator: 'regimen_fiscal'},
  {label: 'Correo', field: 'correo'},
  {label: 'Celular', field: 'celular'},
  {label: 'Línea de crédito solicitada', field: 'linea_credito_solicitada', mutator: 'money_format'},
  {label: 'Tipo de garantía', field: 'tipo_garantia', mutator: 'tipo_garantia'},
  {label: 'Valor estimado del inmueble', field: 'valor_estimado_inmueble', mutator: 'money_format'},
  {label: 'M² de terreno', field: 'superficie_terreno'},
  {label: 'M² construidos', field: 'area_construida'},


  {label: 'Direccion Solicitante (Estado)', field: 'entidad'},
  {label: 'Direccion Solicitante (CP)', field: 'cp'},
  {label: 'Direccion Solicitante (Colonia)', field: 'colonia'},
  {label: 'Direccion Solicitante (Municipio)', field: 'municipio'},
  {label: 'Direccion Solicitante (Calle)', field: 'calle'},
  {label: 'Direccion Solicitante (Numero)', field: 'numero'},
  {label: 'Url Maps', field: 'link_ubicacion'},
]

const tipos_garantias = [
  {label:'Casa', value: 1 },
  {label:'Departamento', value: 3 },
  {label:'Bodega', value: 8},
  {label:'Nave industrial', value: 9},
  {label:'Terreno (Urbanizado)', value: 10},
  {label:'Hotel', value: 11},
  {label:'Local comercial', value: 4 },
  {label:'Edificio', value: 12},
];

export default {
  components: { ColumnsSelect, SearchInput },
  data() {
    return {
      visible_columns: [
        'id', 'nombre', 'email', 'celular', 'promotor', 'rfc', 'status', 'hsbc_product' ,'comentarios', 'created_at', 'updated_at'
      ],
      columns: [
        { name: "nombre", label: "Nombre", field: "nombre_completo", align: "left" },
        { name: "correo", label: "Correo electrónico", field: "email", align: "left" },
        { name: "tipo_garantia", label: "Tipo de garantía", field: "tipo_garantia", align: "left" },
        { name: "created_at", label: "Fecha de creación", field: "created_at", align: "left" },
				{ name: 'promotor', field: '', label: 'Promotor', sortable: true, align: 'left' },
				{ name: 'estatus', field: '', label: 'Estado', sortable: true, align: 'left' },
				{ name: 'col_documentos', field: '', label: '', sortable: true, align: 'left' },
      ],
      contactos: [],
      estatus_documento: [
       { value: 'validado', label: 'Documento validado' },
       { value: 'invalido', label: 'Documento invalido' },
       { value: 'revision', label: 'Pendiente de revisión' },
      ],
      loading: false,
      filter: null,
      lista_tipos_archivos: [
        {
          tag: "fachada",
          label: "Foto de la fachada",
        },
        {
          tag: "inmueble_foto_interior",
          label: "Fotos Interior",
        },
        {
          tag: "inmueble_foto_exterior",
          label: "Fotos Exterior",
        },
      ],
      estatus_archivo_invalido: 'invalido',
      producto: null,
      producto_nombre: null,
      solicitud_id: null,
      solicitud:  { id: null, nombre_completo: '--', archivos:[]}
      ,archivos_del_producto: []
        ,solicitud_documentos_cargados_keys:[]
      ,formEstatusArchivo: false
      ,archivo_seleccionado: {id: null, estatus: null, comentarios_estatus_invalido: null}
      ,tipos_garantias

    }
  },

  computed:{

    promotor(){
      return this.solicitud.hasOwnProperty('usuario') ? this.solicitud.nombre_completo : '--';
    },

    campos_solicitud(){
     switch (this.producto){
       case 'libre':
         return campos_producto_libre
       case 'flex':
         return campos_producto_flex
       case 'anticipo_venta':
         return campos_producto_anticipo_venta
       default:
         return []
     }
    },

    check_list_archivos_producto(){

      if (!this.producto)
        return [];

      return  this.lista_tipos_archivos.filter(archivo => {
        return this.archivos_del_producto.includes(archivo.tag)
      } );
    },

  archivos_pendientes(){
    if (!this.producto)
      return [];

    return !this.check_list_archivos_producto.length ? [] : this.check_list_archivos_producto.filter(archivo => {
      return !this.solicitud_documentos_cargados_keys.includes(archivo.tag)
    } );
  }
  },

  mounted() {

    this.producto = this.$route.params.producto;
    this.solicitud_id = this.$route.params.solicitud;

    this.cargarProducto()
  },

  methods: {

    tipo_garantia(id_garantia){
      const garantia = this.tipos_garantias.find(tipo => tipo.value === id_garantia)
      return typeof garantia !== "undefined" ? garantia.label : id_garantia;
    },


    regimen_fiscal(value){
      switch (value) {
        case 'PM':
          return 'Persona Moral';
        case 'PF':
          return 'Persona Física';
        case 'PFAE':
          return 'Persona Física Con Actividad Empresarial';
        default:
          return value;
      }
    },

    money_format(value){
      return !value ? '$ ---' : this.currency(value)
    },

    async cargarProducto() {
      this.loading = true
      this.archivos_del_producto = []
      this.producto_nombre = null

      try {
        const response = await productosApi.get(this.producto)
        if (response.hasOwnProperty('estatus') && response.estatus == 'activo') {
          this.archivos_del_producto = response.documentos
          this.producto_nombre = response.nombre
          await this.cargarSolicitud()
        } else {

          this.$q.dialog({
            title: "Producto no disponible",
            message: "El producto de la solcitud no esta disponible",
            html: true,
            ok: {
              push: true,
            },
            persistent: true,
          }).onOk(() => {
            this.$router.push({name: 'solicitudes-producto'})
          })

        }

        this.loading = false

      } catch (e) {

        this.$q.dialog({
          title: "Ocurrio un error al cargar la solicitud",
          message: "Intente mas tarde, si el problema persiste favor de contactar a soporte.",
          html: true,
          ok: {
            push: true,
          },
        })
      }
    },


    async cargarSolicitud() {
      try {
        this.loading = true
        this.solicitud = {id: null, nombre_completo: '--', archivos: []}
        this.solicitud_documentos_cargados_keys = []
        this.solicitud = await productosApi.solicitud(this.producto, this.solicitud_id)


        if (this.solicitud.hasOwnProperty('archivos')) {
          this.solicitud_documentos_cargados_keys = this.solicitud.archivos.map(item => item.tipo_archivo)

        } else
          this.solicitud.archivos = []


      } finally {
        this.loading = false
      }
    },

    validarArchivo(archivo) {

      this.archivo_seleccionado = {...archivo}

      if (!this.archivo_seleccionado.hasOwnProperty('comentarios_estatus_invalido')) {
        this.archivo_seleccionado.comentarios_estatus_invalido = null
      }

      this.formEstatusArchivo = true
    },

    async cambiarEstatusArchivo() {
      try {
        this.loading = true

        const resp = await productosApi.actualiza_estatus_archivo(this.producto, this.solicitud_id, this.archivo_seleccionado.id, this.archivo_seleccionado)
        this.$q.notify({
          message: `Estatus actualizado`,
          type: "positive",
          position: "top-right",
        });

        this.formEstatusArchivo = false
        this.cargarSolicitud()

      } catch (e) {

        this.formEstatusArchivo = false
        this.archivo_seleccionado = {id: null, estatus: null, comentarios_estatus_invalido: null}

        //Solo se muestra el dialogó de error si el error no es de validación
        let dialogo_error = !e.response && e.response.code === 422

        if (dialogo_error)
          this.$q.dialog({
            title: "Ocurrio un error al editar estatus del archivo",
            message: "Intente mas tarde, si el problema persiste favor de contactar a soporte.",
            html: true,
            ok: {
              push: true,
            },
            persistent: true,

          }).onOk(() => {
            this.loading = false
          })

      }
    }

    ,async descargarArchivo(archivo){
      this.loading = true

      const request = await productosApi.descargar(this.producto, this.solicitud_id, archivo.id)
      let url = window.URL.createObjectURL(new Blob([request]));
      let link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', archivo.nombre_original);
      document.body.appendChild(link);
      link.click();

      this.loading = false

    }
  },
  watch:{
    "archivo_seleccionado.estatus":{
      handler(newValue, oldValue) {
        if (!!newValue && newValue !== oldValue && newValue !==  this.estatus_archivo_invalido) {
          this.archivo_seleccionado.comentarios_estatus_invalido = null
        }
      }
    }
  }
}
